import React from "react";
import { BreakfastIcon } from "../../../../../styles/img/svg/BreakfastIcon";
import { FoodIcon } from "../../../../../styles/img/svg/FoodIcon";
import { KingBedIcon } from "../../../../../styles/img/svg/KingBedIcon";
import { LaptopIcon } from "../../../../../styles/img/svg/LaptopIcon";
import { ShowerIcon } from "../../../../../styles/img/svg/ShowerIcon";
import { SizeIcon } from "../../../../../styles/img/svg/SizeIcon";
import { TvIcon } from "../../../../../styles/img/svg/TvIcon";
import { WifiIcon } from "../../../../../styles/img/svg/WifiIcon";
import { UiCardTitle } from "../../../components/common/UiCardTitle";


export const Overview = (props) => {
    return (
        <>
            <UiCardTitle title={props.title} />
            <h3>{props.subtitle}</h3>
            <div className='sb-overview-sec-wrapper__tags'>
                <div><WifiIcon />Wi-fi</div>
                <div><ShowerIcon />Bathup</div>
                <div><BreakfastIcon />Breakfast</div>
                <div><KingBedIcon />King bed</div>
                <div><SizeIcon />4m x 6m</div>
                <div><TvIcon />Free wifi 24/7</div>
                <div><ShowerIcon />Free clean bathroom</div>
                <div><FoodIcon />Breakfast included</div>
                <div><TvIcon />Free wifi 24/7</div>
                <div><LaptopIcon />Free computer</div>
                <div><WifiIcon />Free wifi</div>
                <div><FoodIcon />Breakfast included</div>
                <div><ShowerIcon />Free clean bathroom</div>

            </div>
        </>
    )
}
